'use client'

import type { Theme } from '@mui/material/styles'
import { muiTheme } from '@/theme/muiTheme'

let cachedTheme: Theme | null = null

export const loadBaseMuiTheme = (): Theme => {
  if (!cachedTheme) {
    cachedTheme = muiTheme
  }

  return cachedTheme
}

export default loadBaseMuiTheme
